import { render, staticRenderFns } from "./LiveFilter.vue?vue&type=template&id=21fd8b87&scoped=true&lang=pug"
import script from "./LiveFilter.vue?vue&type=script&lang=js"
export * from "./LiveFilter.vue?vue&type=script&lang=js"
import style0 from "./LiveFilter.vue?vue&type=style&index=0&id=21fd8b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd8b87",
  null
  
)

export default component.exports